// uPlot chart fonts (VISUAL_IDENTITY 1.7). uPlot draws to <canvas> and takes
// CSS-shorthand font strings, so it cannot inherit Chart.js's global defaults:
// MONO for numeric text (tick values, tooltip), SANS for prose (axis titles).
// The tick size is shared with the insights rows under the plot, which keep
// clear of the lowest y tick label.
export const CHART_TICK_PX = 12;
export const CHART_MONO_FONT =
  `${CHART_TICK_PX}px 'JetBrains Mono Variable', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace`;
// SANS in pieces too: the x axis title is HTML under the plot (VISUAL_IDENTITY
// 1.7) and must read like the y axis title drawn on the canvas.
export const CHART_SANS_PX = 12;
export const CHART_SANS_FAMILY =
  "'Inter Variable', ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif";
export const CHART_SANS_FONT = `${CHART_SANS_PX}px ${CHART_SANS_FAMILY}`;
// Axis ink (tick values and titles), light and dark.
export const CHART_AXIS_INK = { light: '#374151', dark: '#e5e7eb' };
